import React, { Component } from 'react';
import axios from 'axios';

export default class InlineSVG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      svgContent: null
    }
  }

  componentWillMount() {
    axios.get(this.props.src)
      .then((result) => {
        this.setState({svgContent: result.data});
      })
      .catch((error) => {

      });
  }

  render() {
    return (
      <span dangerouslySetInnerHTML={{
        __html: this.state.svgContent
      }}></span>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/InlineSVG.js